import { createConfirmation } from "react-confirm";
import EntGroupDialog from "./EntGroupDialog";

export const showEntGroupDialog = createConfirmation(EntGroupDialog);
